// src/components/AssetUploadPreviewVerify.js

import React from 'react';
import { TransitionGroup } from 'react-transition-group';
import {
  Box,
  Card,
  CardContent,
  Collapse,
  IconButton,
  Typography,
} from '@mui/material';
import AssetUploadPreviewImage from './AssetUploadPreviewImage';

export default function AssetUploadPreviewVerify({
  files,
  uploading,
  progress,
  onRemoveFile,
  showCloseIcon,
}) {
  return (
    <TransitionGroup>
      {files.map((file) => (
        <Collapse key={file.uploadId}>
          <Card
            elevation={0}
            variant="outlined"
            sx={{
              mb: 0,
              borderRadius: 1,
              borderColor: 'grey.300',
              '&:last-child': {
                pb: 0,
              },
            }}
          >
            <CardContent sx={{ p: 0, '&:last-child': {pb: 0}}}>
              <AssetUploadPreviewImage file={file} uploading={uploading} />
            </CardContent>
          </Card>
        </Collapse>
      ))}
    </TransitionGroup>
  );
}
